import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'

//UsmSign

var firebaseConfig = {
  apiKey: 'AIzaSyBHTKpnDbRypa2tY4ktqnVP4-0Xxb5VJ_g',
  authDomain: 'usm-sign.firebaseapp.com',
  databaseURL: 'https://usm-sign.firebaseio.com',
  projectId: 'usm-sign',
  storageBucket: 'usm-sign.appspot.com',
  messagingSenderId: '1085787410198',
  appId: '1:1085787410198:web:c70aeb9792a1b7b9274a37',
}
firebase.initializeApp(firebaseConfig)
firebase.firestore()
const storage = firebase.storage()

export default firebase
export { storage }
